import { ConsignmentOrdersTable } from '@/components/Templates/ConsignmentOrders';

const ConsignmentOrders = () => {
	return <ConsignmentOrdersTable />;
};

export default ConsignmentOrders;

